import { render, staticRenderFns } from "./UCT.vue?vue&type=template&id=7774f288&scoped=true&lang=pug&"
import script from "./UCT.vue?vue&type=script&lang=js&"
export * from "./UCT.vue?vue&type=script&lang=js&"
import style0 from "./UCT.vue?vue&type=style&index=0&id=7774f288&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7774f288",
  null
  
)

export default component.exports